export default {
    name:'layout',
    data (){
        return {

        }
    },
    created() {
        console.log(this.$route.params.token)
        if(this.$route.params.token != undefined) {
            window.localStorage.setItem("token", this.$route.params.token)
        }
    },
    components: {
        'GridFooter': (resolve) => {
            require(['@/components/footer/footer'], resolve)
        },
    },
}


// WEBPACK FOOTER //
// ./src/page/layout/layout.controller.js